import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { find, get, pickBy } from 'lodash';
import { LeftAndRightAlignment } from 'web-ui-components/lib/global/layout';
import { Label } from 'web-ui-components/lib/atoms/forms';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { IndicativeHighlight } from 'web-ui-components/lib/typography/highlights';
import PEIInfoContent, { contentPropTypes } from './PEIInfoSection.content';
import withContent from '../../../../containers/withContent';
import { whoPaysMapping } from '../../../../config/ift';
import { RatesImportantInfoSection } from '../RatesImportantInfoSection/RatesImportantInfoSection';
import RatesErrorSection from '../RatesErrorSection/RatesErrorSection';

const leftNode = (title = '') => (
	<div>
		<StandardBody>{title}</StandardBody>
	</div>
);

const rightNode = (value = '') => (
	<div>
		<StandardBody>{value}</StandardBody>
	</div>
);
const rightNodeWithHiglight = (value) => (
	<div>
		<IndicativeHighlight.value>{value}</IndicativeHighlight.value>
	</div>
);

export const getAmountTitle = (currency, amount) => `${currency} ${amount}`;

export const getPaymentFeesTitle = (fees, chargingModal) => {
	const getChargingModalContent = get(
		find(whoPaysMapping, (whoPays) => whoPays.id === chargingModal),
		'type'
	);
	return `${fees} (${getChargingModalContent})`;
};
export const PEIInfoSection = ({
	content: {
		amountTitle,
		amount,
		rateTitle,
		feesTitle,
		fees,
		totalAmountTitle,
		sentAmountTitle,
		settlementDateTitle,
		importantInfoTitle,
		importantInfoDescription,
		extraInfo,
		submissionDateTitle,
	},
	rates,
	sendCurrency,
	fromCurrency,
	chargingModal,
}) => {
	const {
		creditAmountWithCurrency,
		debitAmountWithCurrency,
		exchangeRate,
		paymentFees,
		settlementDate,
		submissionDate,
		remittanceAmount,
		isMissedCurrency,
	} = rates;
	const amountSummary = pickBy({
		[rateTitle]: exchangeRate,
		[getAmountTitle(fromCurrency, amount)]: debitAmountWithCurrency,
	});
	const feesSummary = pickBy({
		[getPaymentFeesTitle(fees, chargingModal)]: paymentFees,
	});
	const totalAmountSummary = pickBy({
		[sentAmountTitle]: remittanceAmount,
		[submissionDateTitle]: submissionDate,
		[settlementDateTitle]: settlementDate,
	});
	const isDifferentCurrency = sendCurrency !== fromCurrency;
	return (
		<div>
			<Label htmlFor="test">{amountTitle}</Label>
			<LeftAndRightAlignment
				leftNode={leftNode(getAmountTitle(sendCurrency, amount))}
				rightNode={rightNode(creditAmountWithCurrency)}
			/>
			{isDifferentCurrency &&
				Object.keys(amountSummary).map((amountKey) => (
					<LeftAndRightAlignment
						key={amountKey}
						leftNode={leftNode(amountKey)}
						rightNode={rightNodeWithHiglight(amountSummary[amountKey])}
					/>
				))}
			<Label htmlFor="test">{feesTitle}</Label>
			{Object.keys(feesSummary).map((feesKey) => (
				<LeftAndRightAlignment key={feesKey} leftNode={leftNode(feesKey)} rightNode={rightNode(feesSummary[feesKey])} />
			))}
			<Label htmlFor="test">{totalAmountTitle}</Label>
			<HighlightTile type="note">
				{Object.keys(totalAmountSummary).map((totalAmountKey) => (
					<LeftAndRightAlignment
						key={totalAmountKey}
						leftNode={leftNode(totalAmountKey)}
						rightNode={rightNode(totalAmountSummary[totalAmountKey])}
					/>
				))}
			</HighlightTile>
			{isMissedCurrency && <RatesErrorSection contentKey="missedCurrencyCutOffContent" />}
			<RatesImportantInfoSection
				title={importantInfoTitle}
				description={importantInfoDescription}
				extraInfo={extraInfo}
			/>
		</div>
	);
};
PEIInfoSection.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	rates: PropTypes.shape({}).isRequired,
	sendCurrency: PropTypes.string.isRequired,
	fromCurrency: PropTypes.string.isRequired,
	chargingModal: PropTypes.string.isRequired,
};
export default compose(withContent({ content: PEIInfoContent }))(PEIInfoSection);
